/* eslint-disable @typescript-eslint/no-empty-function */
import { ReactElement, useState, createContext } from 'react';
import React from 'react';
import { AppConfiguration, OptionsInterface } from '../lib/type';
import { Scenario } from '../data/constants';
import './LeadershipAssessment.scss';
import Intro from './Intro/Intro';
import Questions from './Questions/Questions';
import Results from './Results/Results';

export interface LeadershipAsssessmentProps {
  /**
   * All the configuration for the map
   */
  configuration: AppConfiguration;
}
// Defining a type for selectedOption context element

const initialselectedAnswers: any = [];

export const layoutContext = createContext({
  currentScenario: '',
  setCurrentScenario: (type: Scenario) => {},
  currentQuestion: 1,
  setCurrentQuestion: (type: number) => {},
  selectedOption: '',
  setSelectedOption: (type: string) => {},
  optionValue: 0,
  setOptionValeu: (type: number) => {},
  score: 0,
  setScore: (type: number) => {},
  selectedAnswers: initialselectedAnswers,
  setSelectedAnswers: (type: any) => {},
});

const LeadershipAsssessment = ({
  configuration,
}: LeadershipAsssessmentProps): ReactElement => {
  const [currentScenario, setCurrentScenario] = useState(Scenario.introduction);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [selectedOption, setSelectedOption] = useState('');
  const [optionValue, setOptionValeu] = useState(0);
  const [score, setScore] = useState(0);
  const [selectedAnswers, setSelectedAnswers]: any[] = useState([]);

  const handleScenario = () => {
    switch (currentScenario) {
      case 'introduction':
        return <Intro contents={configuration.introduction} />;
      case 'questions':
        return (
          <Questions
            contents={configuration.questions}
            sideBar={configuration.sideBar}
          />
        );
      case 'results':
        return <Results contents={configuration.results} />;
      default:
        return <Intro contents={configuration.introduction} />;
    }
  };

  return (
    <layoutContext.Provider
      value={{
        currentScenario,
        setCurrentScenario,
        currentQuestion,
        setCurrentQuestion,
        selectedOption,
        setSelectedOption,
        optionValue,
        setOptionValeu,
        score,
        setScore,
        selectedAnswers,
        setSelectedAnswers,
      }}
    >
      <div className="leadership-assessment widget-styles">
        {handleScenario()}
      </div>
    </layoutContext.Provider>
  );
};

export default LeadershipAsssessment;
